import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

const propTypes = {
  routes    : PropTypes.array,
  pageUtils : PropTypes.object
}

const AppRoutes = ({ routes = [], pageUtils = {} }) => {
  const renderRoutes = (items) =>
    items.flatMap((route, idx) => {
      if (route.collapse && Array.isArray(route.views)) return renderRoutes(route.views)
      if (route.layout === '/app' && route.component) {
        const Comp = route.component
        return (
          <Route
            key={`${route.path}-${idx}`}
            exact
            path={route.layout + route.path}
            render={(props) => {
              const currentRole = window.__currentAdmin?.role || ''
              const allowedRoles = route.allowedRoles

              if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !allowedRoles.includes(currentRole)) {
                return <Redirect to="/app/sales/bagspa/dashboard" />
              }

              return <Comp {...props} pageUtils={pageUtils} />
            }}
          />
        )
      }
      return []
    })

  return (
    <Switch>
      {renderRoutes(routes)}
      <Redirect to="/app/sales/bagspa/dashboard" />
    </Switch>
  )
}

AppRoutes.propTypes = propTypes
export default AppRoutes
